import { FC } from 'react';
import { MenuButton as BaseMenuButton, MenuButtonProps, Button, useTheme } from '@chakra-ui/react';
import { CaretDown } from 'components/Icons/Icons';
import { rem } from 'utils/fonts';
import { rgba } from 'polished';

interface Props extends MenuButtonProps {
  rightIcon?: boolean;
  showMenuList?: boolean;
  isActive?: boolean;
  isOpen?: boolean;
  activeLinkHighlightPadding?: number;
  openedMenuHighlightPadding?: number;
}

const highlightStyles = {
  content: '""',
  position: 'absolute',
  borderRadius: '4px',
  transition: 'all 0.2s ease-in-out',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  height: '40px',
};

const MenuButton: FC<Props> = ({
  rightIcon = false,
  showMenuList = true,
  isActive = false,
  isOpen,
  activeLinkHighlightPadding = 0,
  openedMenuHighlightPadding = 0,
  children,
  ...props
}) => {
  const { colors } = useTheme();

  return (
    <BaseMenuButton
      rightIcon={rightIcon ? <CaretDown /> : null}
      bgColor="transparent"
      minW="auto"
      height="auto"
      p="0"
      as={Button}
      {...props}
      _hover={{
        bgColor: 'transparent',
        cursor: showMenuList ? 'pointer' : 'default',
      }}
      _before={{
        ...highlightStyles,
        opacity: isOpen ? '1' : '0',
        bgColor: 'primary.400',
        zIndex: '-1',
        width: `calc(100% + ${2 * openedMenuHighlightPadding}px)`,
      }}
      _after={{
        ...highlightStyles,
        opacity: isActive ? '0.15' : '0',
        bgColor: 'white',
        width: `calc(100% + ${2 * activeLinkHighlightPadding}px)`,
      }}
      _focus={{
        boxShadow: 'none',
      }}
      sx={{
        '& > span:last-of-type svg': {
          fontSize: rem(16),
          marginLeft: '13px',
          color: rgba(colors.white, 0.5),
        },

        '& > span:only-child svg': {
          marginLeft: '0',
        },
      }}
    >
      {children}
    </BaseMenuButton>
  );
};

export default MenuButton;
